import { Module } from '../Module';
import { PKCEService } from '../services/PKCEService';
import { WindowLocationService } from '../services/WindowLocationService';

export interface IPKCEGenerateCodeChallengeCtrlStateParams {
  appUriProtocol?: string;
}

export class PKCEGenerateCodeChallengeCtrl {

  public static $inject = [
    '$stateParams',
    'PKCEService',
    'WindowLocationService',
  ];

  constructor(
    $stateParams: IPKCEGenerateCodeChallengeCtrlStateParams,
    PKCEService: PKCEService,
    WindowLocationService: WindowLocationService
  ) {
    const codeChallenge = PKCEService.generateCodeChallenge();
    const nextStateUrl = '/?openExternal=true#/pkce/getAuthorizationCode'
      + '?appUriProtocol=' + $stateParams.appUriProtocol
      + '&codeChallenge=' + codeChallenge.codeChallenge
      + '&codeChallengeMethod=' + codeChallenge.codeChallengeMethod;

    WindowLocationService.navigateTo(nextStateUrl);
  }
}

Module.instance().controller('PKCEGenerateCodeChallengeCtrl', PKCEGenerateCodeChallengeCtrl);
